/**
 * Simple confetti effects for Election Day Check-In success
 */
export function triggerConfetti() {
  // Create a script element
  const script = document.createElement('script');
  script.src = 'https://cdn.jsdelivr.net/npm/canvas-confetti@1.6.0/dist/confetti.browser.min.js';
  script.async = true;
  
  script.onload = () => {
    const duration = 4 * 1000; // 3 seconds total
    const animationEnd = Date.now() + duration;
    const defaults = { 
      startVelocity: 10, // Further reduced for even slower movement
      spread: 280, // Slightly tighter spread
      ticks: 80, // Increased for longer-lasting particles
      gravity: 0.3, // Reduced gravity for slower fall
      zIndex: 0 
    };

    const randomInRange = (min, max) => Math.random() * (max - min) + min;

    const interval = setInterval(() => {
      const timeLeft = animationEnd - Date.now();

      if (timeLeft <= 0) {
        return clearInterval(interval);
      }

      const particleCount = 60 * (timeLeft / duration); // Doubled from 30 to 60 for more confetti
      
      // Fireworks effect
      window.confetti({
        ...defaults,
        particleCount,
        origin: { x: randomInRange(0.1, 0.3), y: Math.random() - 0.2 }
      });
      
      window.confetti({
        ...defaults,
        particleCount,
        origin: { x: randomInRange(0.7, 0.9), y: Math.random() - 0.2 }
      });
      
      // Add middle confetti for more volume
      window.confetti({
        ...defaults,
        particleCount: particleCount * 0.5,
        origin: { x: randomInRange(0.4, 0.6), y: 0 }
      });
    }, 600); // Further increased for slower bursts
  };
  
  document.body.appendChild(script);
}
